module.exports = __webpack_public_path__ + "static/img/no_image_x300.d544f5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/no_image_x300.png
// module id = 4sVx
// module chunks = 1